import * as React from 'react';

import Validatable from 'components/form/Validatable';

import type { FormValidator } from 'types';

type ContextType = {
  registerValidators: (component: Validatable, validators: Array<FormValidator>) => void,
  unregisterValidators: (component: Validatable) => void
};

const ValidatorContext = React.createContext<ContextType>({
  registerValidators: () => {},
  unregisterValidators: () => {}
});

export default ValidatorContext;
